import type { AdminTicketDetailsDto } from "@/api/types";
import { UserDetailsContent } from "@/components/UserDetailsContent/UserDetailsContent";
import { SectionCard } from "@/design-system/SectionCard";
import { useTranslation } from "@/translations";

interface TicketReporterCardProps {
  ticket: AdminTicketDetailsDto;
  canNavigate?: boolean;
}

export function TicketReporterCard({ ticket, canNavigate = false }: TicketReporterCardProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <SectionCard label={t("page.tickets.details.user.reporter")}>
      <UserDetailsContent
        user={{
          ...ticket.user,
          phoneNumber: ticket.phoneNumber || ticket.user.phoneNumber,
        }}
        canNavigate={canNavigate}
        showAddressDetails
        address={{
          building: ticket.address?.building.name,
          floor: ticket.address?.floor,
          apartmentType: ticket.address?.typeConstraint?.key,
        }}
      />
    </SectionCard>
  );
}
